import Vue from 'vue'
import Router from 'vue-router'
import VueMoment from 'vue-moment'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import Page from '@/components/Page'
import Staff from '@/components/Staff'
import NewsPage from '@/components/NewsPage'
import NewsDetail from '@/components/NewsDetail'
import ITContactList from '@/components/ITContactList'
import ArticleList from '@/components/ArticleList'
import ArticleDetail from '@/components/ArticleDetail'

Vue.use(Router)

const moment = require('moment')

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(value, 'YYYY-MM-DD HH:mm:ss ').format('D MMMM YYYY');
    }
});

export default new Router({
    routes: [{
            path: '/',
            name: 'Login',
            component: Login
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard
        },
        {
            path: '/news',
            name: 'News',
            component: NewsPage
        },
        {
            path: '/news-detail/:id/:slug?',
            name: 'NewsDetail',
            component: NewsDetail
        },
        {
            path: '/page/:name',
            name: 'Page',
            component: Page
        },        {
            path: '/staff',
            name: 'Staff',
            component: Staff
        },        {
            path: '/it-contact-list',
            name: 'ITContactList',
            component: ITContactList
        },        {
            path: '/articles',
            name: 'Articles',
            component: ArticleList
        },
        {
            path: '/article/:groupId',
            name: 'ArticleList',
            component: ArticleList
        },        {
            path: '/article/:groupId/embed/:linkId',
            name: 'ArticleDetailEmbed',
            component: ArticleDetail
        },
        {
            path: '/article/:groupId/external/:linkId',
            name: 'ArticleDetailExternal',
            component: ArticleDetail
        },
        {
            path: '/article/:groupId/:linkId',
            name: 'ArticleDetail',
            component: ArticleDetail
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js